export const containsNbsp = (value: string) => {
  return /&nbsp;/gi.test(value) || /\u00A0/g.test(value)
}
